import { useEffect } from "react";

// Canal compartido con el service worker (firebase-messaging-sw.js).
// Cuando llega una notificación en background, el SW no puede reproducir
// audio directamente, así que publica en este canal para que el tab activo
// lo haga por él.
const CHANNEL_NAME = "fcm-notification-sound";

export const useBackgroundNotification = (onNotification) => {
  useEffect(() => {
    if (!("BroadcastChannel" in window)) return;

    const channel = new BroadcastChannel(CHANNEL_NAME);

    channel.onmessage = (event) => {
      if (event.data?.type === "PLAY_SOUND") {
        onNotification(event.data.payload);
      }
    };

    return () => channel.close();
  }, [onNotification]);
};
